import { Experience } from '../types';

export const experiences: Experience[] = [
  {
    id: 'yper-lead-tech',
    company: 'YPER',
    role: 'Lead Tech',
    startDate: '2025-04-01',
    endDate: '2026-03-31',
    location: 'Roubaix, France (flex/full-remote)',
    description:
      'Management des équipes back-end et front-end (10 développeurs).<br />Suivi des projets et facilitation de la communication entre équipes techniques et métier.<br /><em>En complément des missions de Lead Développeuse Backend.</em>',
    skills: ['Management d\'équipe', 'Gestion de projet', 'Coordination technique/métier', 'Python', 'Architecture API', 'Méthode AGILE'],
    type: 'tech'
  },
  {
    id: 'yper-lead',
    company: 'YPER',
    role: 'Lead Développeuse Backend - Python',
    startDate: '2024-01-01',
    endDate: '2025-03-30',
    location: 'Roubaix, France (flex/full-remote)',
    description:
      'Management de l\'équipe back-end (4 développeurs).<br />Recueil des besoins, rédaction des spécifications et cahiers des charges.<br />Conception des solutions techniques et argumentation des choix devant les parties prenantes.<br />Définition et pilotage de la roadmap technique.<br />Animation des instances Agile (sprint planning, démos, rétrospectives).<br />Suivi qualité des livrables, supervision des mises en production.<br />Gestion des intégrations partenaires et coordination des réalisations.<br />Présentation des évolutions du SI au commanditaire.<br />Renforcement de la sécurité et réduction des coûts d\'infrastructure.',
    skills: ['Management', 'Rédaction de spécifications', 'Cahiers des charges', 'Parties prenantes', 'Python', 'Architecture API', 'Méthode AGILE'],
    type: 'tech'
  },
  {
    id: 'yper-dev',
    company: 'YPER',
    role: 'Développeuse Backend - Python',
    startDate: '2020-09-01',
    endDate: '2023-12-31',
    location: 'Roubaix, France',
    description:
      'Développement et maintenance de solutions techniques en lien avec l\'équipe produit.<br />Intégration technique de partenaires externes (déploiement, tests, recette).<br />Planification des tests et participation aux mises en production.<br />Amélioration continue du code, astreintes et veille technologique.<br />Rédaction et maintien à jour de la documentation technique.',
    skills: ['Python', 'API REST', 'Intégrations partenaires', 'DevOps', 'Documentation technique', 'Méthode AGILE'],
    type: 'tech'
  },
  {
    id: 'odiso',
    company: 'ODISO',
    role: 'Développeuse Backend',
    startDate: '2019-06-01',
    endDate: '2020-08-31',
    location: 'La Madeleine, France',
    description:
      '<em>Stage (3 mois) puis Alternance (12 mois).</em><br />Développement d\'outils sur l\'ERP interne (Django) pour automatiser des processus clés (pare-feux, machines virtuelles, facturation).',
    skills: ['Django', 'Python', 'Automatisation'],
    type: 'tech'
  }
];

export const otherExperiences: Experience[] = [
  {
    id: 'whatsup',
    company: 'What\'s up',
    role: 'Agent d\'accueil (Salle d\'escalade)',
    startDate: '2018-09-01',
    endDate: '2019-05-31',
    location: 'Lesquin, France',
    description:
      'Emploi étudiant (20h/semaine).<br />Accueil et orientation des clients. Réalisation des briefings de sécurité pour l\'activité Clip\'n Climb. Service au bar (boissons/pizzas). Entretien général des espaces.',
    skills: ['Relation client', 'Rigueur', 'Polyvalence', "Dynamisme"],
    type: 'other'
  },
  {
    id: 'wwoofing',
    company: 'Fruit of Life',
    role: 'Wwoofing',
    startDate: '2017-08-01',
    endDate: '2017-08-31',
    location: 'Dwingeloo, Pays-Bas',
    description:
      'Cueillette et conditionnement des myrtilles. Supervision d’équipes de jeunes cueilleurs. Gestion logistique d’une terrasse rurale.',
    skills: ['Anglais', 'Management'],
    type: 'other'
  },
  {
    id: 'flams',
    company: 'Flam\'s',
    role: 'Serveuse',
    startDate: '2016-08-01',
    endDate: '2017-06-30',
    location: 'Lille, France',
    description: 'Emploi étudiant (10h/semaine).',
    type: 'other'
  }
];
